<ul class="gap-5 flex flex-col ">
    @for (list of model(); track $index) {
        <li class="flex flex-col gap-4 text-[22px] font-medium">
            {{list.label}}
            @for (subList of list.items; track subList.label) {

                <li routerLinkActive="text-red-500"
                    style=""
                    class="ml-3 flex gap-2 text-[16px] hover:text-red-500 items-center cursor-pointer"
                    [routerLink]="subList.routerLink">
                    <i class="{{subList.icon}}"></i>
                    <span>{{ subList.label }}</span>
                    @if (subList.badge && bages() && subList.badge !== '0') {
                        <p-badge class="ml-auto" [value]="subList.badge" severity="info" />
                    }
                </li>
            }
        </li>
    }
    <li
        class="text-[20px] hover:text-red-500 text-center cursor-pointer"
        (click)="this.auth.logout()"
    >Выйти</li>
</ul>
